import { CommonModule, DatePipe, Location } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx-js-style';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexStroke,
  ApexFill,
  NgApexchartsModule,
  ChartComponent
} from "ng-apexcharts";
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
declare let $: any;
@Component({
  selector: 'app-new-payroll',
  imports: [CommonModule, RouterModule, CommonModule, FormsModule, NgApexchartsModule],
  templateUrl: './new-payroll.component.html',
  styleUrl: './new-payroll.component.css',
  providers: [DatePipe],
})
export class NewPayrollComponent implements OnInit {
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  showOptions = false;
  actionOptions = false;
  public selected_date: any = [];
  public usersList: any = [];
  month_data: any;
  public totalSalary: any = [];
  public total_shourtHours: any = [];
  public total_lateCheckin: any = [];
  public total_unpaidLeaves: any = [];
  public total__absents: any = [];
  public total_Advance: any = [];
  public total_Overtime: any = [];
  public total_tax: any = [];
  public loan_amount: any = [];
  public total_otherDeduction: any = [];
  public total_Compensation: any = [];
  public totalDeduction: any = [];
  public totalReleasedSalary: any = [];

  // Flag properties to hide/show columns
  public hasAdvance = false;
  public hasOvertime = false;
  public hasLoanAmount = false;
  public hasOtherDeduction = false;
  public month_char!: string | null;
  public month_year!: number | null;
  public month_int!: number | null;
  public status = '';
  public showSpinner = false;

  selectionMode: any
  deductionGraphData: any[] = [];
  public chartOptions: {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    stroke?: ApexStroke;
    fill?: ApexFill;
  };

  statusMap: Record<string, { text: string; class: string; tooltip?: string }> = {
    processing: { text: 'Processing', class: 'process' },
    waiting: { text: 'Waiting for Approval', class: 'waiting' },
    ready_to_release: { text: 'Ready to Release', class: 'realese' },
    change_req: {
      text: 'Changes Required',
      class: 'change-req',
      tooltip: 'Attendance data conflict. Please recheck employee presence'
    },
    released: { text: 'Released', class: 'release' },
    canceled: { text: 'Canceled', class: 'cancel' },
    draft: { text: 'Draft', class: 'draft' },
    approved: { text: 'Approved', class: 'approved' },
  };
  selectedPayroll: any;
  showSkeleton = true;
  currentSelectionAction: 'approved' | 'released' | null = null;
  fileName: any;
  statusCounts = {
    approved: 0,
    released: 0,
    draft: 0,
  };
  monthlyStatus = {
    approved: [0],
    released: [0],
    draft: [0]
  };
  graph = false;
  total_absents_count: any = [];
  total_lateCheckin_count: any = [];
  total_shourtHours_count: any = [];
  total_unpaidLeaves_count: any = [];
  reviewButton = false;
  prseMonthChar: any;
  prseMonth: any;
  prseYear: any;
  total_salary_id: any;
  exist_salary: any;
  payrol_id: any;
  exist_status: any;
  enableGraph = false;
  salary_status: any;
  user: any;
  refresh: any;
  resignationapi: any;
  resign_status: any;

  constructor(

    public payrollService: PayrollService,
    public router: Router,
    public activated_route: ActivatedRoute,
    public dashboardService: DashboardService,
    public datepipe: DatePipe,
    private location: Location


  ) {

    this.user_refresh();
    const userInfo = localStorage.getItem('user');


    if (userInfo != null) {
      this.user = JSON.parse(localStorage.getItem('user') || '') || '';
    }





    this.chartOptions = {
      series: [
        { name: 'Release', data: [] },
        { name: 'Approved', data: [] },
        { name: 'Draft', data: [] }
      ],
      chart: {
        type: 'area',
        height: 160,
        toolbar: { show: false },
        sparkline: { enabled: true }
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      fill: {
        type: 'gradient',
        gradient: {
          opacityFrom: 0.6,
          opacityTo: 0.05
        }
      }
    };
  }
  ngOnInit(): void {


    const fromPayrollList = history.state?.fromPayrollList;

    if (fromPayrollList) {
      this.getcurrentData();


    } else {
      this.activated_route.queryParams.subscribe(params => {

        if (!params['month'] || !params['year']) {
          Swal.fire({
            icon: 'warning',
            title: 'Missing Parameters',
            text: 'Month and Year are required to view this data.',
            confirmButtonText: 'OK'
          });
          return; // stop execution
        }
        this.month_int = +params['month']; // 1–12
        this.month_year = +params['year'];
        this.graph = params['graph'];
        this.payrol_id = params['id'];
        this.getdetailMonthPayroll();
        this.checkSalary(this.month_year, this.month_int);

        // Create a date from month & year
        const date = new Date(this.month_year, this.month_int - 1, 1);

        this.month_char = this.datepipe.transform(date, 'MMMM') ?? '';

        this.getData(this.month_char, this.month_year, this.month_int);
        this.getMonthPayroll();

      });
    }






    // this.selected_date = this.activated_route.snapshot.paramMap.get('selected_date')
    // var date = new Date(this.selected_date);
    // this.month_char = this.datepipe.transform(date, "MMMM")
    // this.month_year = date.getFullYear()
    // this.month_int = date.getMonth() + 1
    // this.getData(this.month_char ?? "", this.month_year, this.month_int)
  }

  toggleOptions(event: Event) {
    event.stopPropagation(); // prevent clickOutside from firing
    this.activeSubMenu = null;
    this.showOptions = !this.showOptions;
    this.actionOptions = false; // close other dropdown
  }

  toggleactionOptions(event: Event) {
    event.stopPropagation();
    this.actionOptions = !this.actionOptions;
    this.showOptions = false; // close other dropdown
  }

  onOptionSelect(option: string) {
    this.showOptions = false;
    this.actionOptions = false;
    this.activeSubMenu = null;
    switch (option) {

      case 'approve-all':
        this.currentSelectionAction = 'approved';
        this.selectionMode = true;

        this.usersList.forEach((user: any) => user.selected = true);
        break;

      case 'approve-selected':
        this.currentSelectionAction = 'approved';
        this.selectionMode = true;
        this.usersList.forEach((user: any) => user.selected = false);
        break;

      case 'release-all':
        this.currentSelectionAction = 'released';
        this.selectionMode = true;
        this.usersList.forEach((user: any) => user.selected = true);
        break;

      case 'release-selected':
        this.currentSelectionAction = 'released';
        this.selectionMode = true;
        this.usersList.forEach((user: any) => user.selected = false);
        break;
      case 'Preview':
        if ((this.totalDeduction == 0) && (this.totalSalary == 0)) {
          this.showSkeleton = true;

          Swal.fire({
            iconHtml: '<img src="../../assets/images/error-modal.svg" alt="image">',
            title: 'Kindly First Generate Payroll To preview',
            showConfirmButton: false,
            timer: 2000,
          })
          this.showSkeleton = false;
        } else {
          this.router.navigate(
            ['preview-payroll'],
            {
              state: {
                usersList: this.usersList,
                month_char: this.month_char,
                month_year: this.month_year,
                month_int: this.month_int,
                salary_id: this.total_salary_id,
                totals: {
                  totalSalary: this.totalSalary,
                  totalDeduction: this.totalDeduction,
                  total_Overtime: this.total_Overtime,
                  total_Compensation: this.total_Compensation,
                  total_tax: this.total_tax
                }
              }
            }
          );
        }

        break;

    }
  }

  get totalUsers(): number {
    return this.usersList.length;
  }

  // Selected users count
  get selectedUsersCount(): number {
    return this.usersList.filter((user: any) => user.selected).length;
  }
  cancelSelection() {
    this.selectionMode = false;
    this.usersList.forEach((user: any) => user.selected = false);
  }

  getSelectedUsers() {
    return this.usersList.filter((user: any) => user.selected);
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (
      this.dropdownContainer &&
      !this.dropdownContainer.nativeElement.contains(event.target)
    ) {
      this.showOptions = false;
      this.actionOptions = false;
      this.activeSubMenu = null; // ✅ close submenu also
    }
  }


  activeSubMenu: 'approve' | 'release' | null = null;

  toggleSubMenu(menu: 'approve' | 'release', event: Event) {
    event.stopPropagation(); // prevent outside click
    this.activeSubMenu = this.activeSubMenu === menu ? null : menu;
  }




  getData(month: string, year: number, monthInt: number) {
    this.dashboardService.getAllUserSalariesMonthly(month, year, monthInt).then((value: any) => {

      this.usersList = value.data;

      // Sort according to status: approved/released first, then draft, etc.
      this.usersList.sort((a: any, b: any) => {
        const getWeight = (user: any) => {
          const status = user?.user_salary?.[0]?.status?.trim().toLowerCase() || 'draft';
          if (status === 'approved' || status === 'released') return 1;
          if (status === 'draft') return 3;
          return 2;
        };
        return getWeight(a) - getWeight(b);
      });


      this.totalSalary = 0
      this.totalDeduction = 0
      this.totalReleasedSalary = 0
      this.total_shourtHours = 0
      this.total_lateCheckin = 0
      this.total_unpaidLeaves = 0
      this.total__absents = 0
      this.total_Advance = 0
      this.total_Overtime = 0
      this.total_tax = 0
      this.loan_amount = 0
      this.total_otherDeduction = 0
      this.total_Compensation = 0
      this.total_shourtHours_count = 0
      this.total_lateCheckin_count = 0
      this.total_unpaidLeaves_count = 0
      this.total_absents_count = 0
      this.status = 'draft';

      this.hasAdvance = false;
      this.hasOvertime = false;
      this.hasLoanAmount = false;
      this.hasOtherDeduction = false;

      this.usersList.forEach((user: any) => {
        if (user.user_salary?.length > 0) {
          this.totalSalary += parseFloat(user.user_salary[0].basic_salary)
          if (user.user_salary[0].total_deduction != null) {
            this.totalDeduction += parseFloat(user.user_salary[0].total_deduction)
          }
          if (user.user_salary[0].released_salary != null) {
            this.totalReleasedSalary += parseFloat(user.user_salary[0].released_salary)
          }

          if (user.user_salary[0].short_hours_amount != null) {
            this.total_shourtHours += parseFloat(user.user_salary[0].short_hours_amount)
          }

          if (user.user_salary[0].short_hours != null) {
            this.total_shourtHours_count += parseFloat(user.user_salary[0].short_hours)
          }

          if (user.user_salary[0].late_check_in_amount != null) {
            this.total_lateCheckin += parseFloat(user.user_salary[0].late_check_in_amount)
          }

          if (user.user_salary[0].late_check_in != null) {
            this.total_lateCheckin_count += parseFloat(user.user_salary[0].late_check_in)
          }

          if (user.user_salary[0].unpaid_leaves_amount != null) {
            this.total_unpaidLeaves += parseFloat(user.user_salary[0].unpaid_leaves_amount)
          }

          if (user.user_salary[0].unpaid_leaves != null) {
            this.total_unpaidLeaves_count += parseFloat(user.user_salary[0].unpaid_leaves)
          }


          if (user.user_salary[0].absents_amount != null) {
            this.total__absents += parseFloat(user.user_salary[0].absents_amount)
          }
          if (user.user_salary[0].absents != null) {
            this.total_absents_count += parseFloat(user.user_salary[0].absents)
          }

          if (user.user_salary[0].advance_payment != null) {
            const val = parseFloat(user.user_salary[0].advance_payment);
            this.total_Advance += val;
            if (val > 0) this.hasAdvance = true;
          }

          if (user.user_salary[0].overtime_amount != null) {
            const val = parseFloat(user.user_salary[0].overtime_amount);
            this.total_Overtime += val;
            if (val > 0) this.hasOvertime = true;
          }

          if (user.user_salary[0].tax != null) {
            this.total_tax += parseFloat(user.user_salary[0].tax)
          }
          // Loan Amount munib
          if (user.user_salary[0].loan_deduction_amount != null) {
            const val = parseFloat(user.user_salary[0].loan_deduction_amount);
            this.loan_amount += val;
            if (val > 0) this.hasLoanAmount = true;
          }
          if (user.user_salary[0].other_deduction != null) {
            const val = parseFloat(user.user_salary[0].other_deduction);
            this.total_otherDeduction += val;
            if (val > 0) this.hasOtherDeduction = true;
          }

          if (user.user_salary[0].compensation_amount != null) {
            this.total_Compensation += parseFloat(user.user_salary[0].compensation_amount)
          }
          if (user.user_salary[0].status != null) {
            this.status += parseFloat(user.user_salary[0].status)
          }
        }
      });
      console.log(this.totalDeduction, this.totalSalary);

      this.statusCounts = this.getStatusCounts(this.usersList);
      this.updateChart(this.statusCounts);
      this.prepareDeductionGraph(this.totalDeduction);

      this.showSkeleton = false;

    });
  }

  totalmodalDeduction(payrollData: any) {

    this.selectedPayroll = payrollData;
  }



  editPayroll(user: any) {
    this.router.navigate(['/add-new-payroll'], { queryParams: { userId: user.id } });
  }

  getStatus(user: any) {
    const statusKey = user?.user_salary[0]?.status.trim() || 'draft';
    return this.statusMap[statusKey] || { text: 'Draft', class: 'draft' };
  }

  getPaymentTypeClass(user: any): string {
    const statusKey = user?.user_salary?.[0]?.status?.trim()?.toLowerCase() || 'draft';
    if (statusKey === 'draft') return 'bg-draft';

    const paymentType = user?.user_salary?.[0]?.payment_type;
    if (paymentType === 'bank_transfer') return 'bg-bank-transfer';
    if (paymentType === 'cash') return 'bg-cash';
    if (paymentType === 'final') return 'bg-final-settlement';
    return '';
  }

  formatPaymentType(paymentType: string): string {
    if (paymentType === 'bank_transfer') return 'Bank Transfer';
    if (paymentType === 'cash') return 'Cash Payment';
    if (paymentType === 'final') return 'Final Settlement';
    return paymentType || 'N/A';
  }

  getStatusCounts(users: any[]) {
    const counts = { approved: 0, released: 0, draft: 0 };

    users.forEach(user => {
      const status = user?.user_salary?.[0]?.status?.trim() || 'draft';

      if (status === 'approved') counts.approved++;
      else if (status === 'released') counts.released++;
      else counts.draft++;
    });


    return counts;
  }


  openDeductionModal(payroll: any) {
    this.selectedPayroll = payroll;
  }



  toggleUser(user: any) {
    user.selected = !user.selected;
  }

  toggleSelectAll() {
    const selectAll = !this.isAllSelected();
    this.usersList.forEach((user: any) => (user.selected = selectAll));
  }

  isAllSelected(): boolean {
    return this.usersList.length > 0 &&
      this.usersList.every((user: any) => user.selected);
  }

  SalaryCalcutlation() {
    this.router.navigate(['/salary-calculations']);
  }



  exportexcel() {
    this.fileName = `Full_Salary_Sheet_${this.month_char}_${this.month_year}.xlsx`;

    // 🔹 Get original table
    const element = document.getElementById('excel-table');
    // 🔒 Safety check
    if (!element) {
      console.error('Excel table not found');
      return;
    }
    // 🔹 Clone table (IMPORTANT)
    const clonedTable = element.cloneNode(true) as HTMLElement;

    // 🔹 Remove tooltips from cloned table
    clonedTable.querySelectorAll('.export-ignore').forEach(el => el.remove());

    // 🔹 Convert cloned table to worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(clonedTable);

    // ---------------- EXISTING CODE CONTINUES ---------------- //

    const wscols = [
      { wch: 20 }, { wch: 12 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
      { wch: 14 }, { wch: 14 },
    ];
    ws['!cols'] = wscols;

    const range = XLSX.utils.decode_range(ws['!ref'] as string);
    const wsRows = [];
    for (let i = 0; i <= range.e.r; i++) {
      wsRows.push({ hpt: 40 });
    }
    ws['!rows'] = wsRows;

    for (let r = range.s.r; r <= range.e.r; r++) {
      for (let c = range.s.c; c <= range.e.c; c++) {
        const cellAddress = XLSX.utils.encode_cell({ r, c });
        if (!ws[cellAddress]) continue;

        ws[cellAddress].s = {
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          font: { sz: 10 },
          border: {
            top: { style: 'thin', color: { rgb: '488dd1' } },
            bottom: { style: 'thin', color: { rgb: '488dd1' } },
            left: { style: 'thin', color: { rgb: '488dd1' } },
            right: { style: 'thin', color: { rgb: '488dd1' } }
          }
        };

        if (r === 0 || r === 1 || r === range.e.r) {
          ws[cellAddress].s.fill = { fgColor: { rgb: '112A5F' } };
          ws[cellAddress].s.font = { color: { rgb: 'FFFFFF' } };
        } else if (r === range.e.r - 1) {
          ws[cellAddress].s.fill = { fgColor: { rgb: '9d9fa1' } };
        } else if (c === 2) {
          ws[cellAddress].s.fill = { fgColor: { rgb: 'FAD3D0' } };
        } else if (c === 13 && r > 0 && r < range.e.r - 1) {
          ws[cellAddress].s.fill = { fgColor: { rgb: 'B6F4A7' } };
        } else {
          ws[cellAddress].s.fill = { fgColor: { rgb: 'E7EBF4' } };
        }
      }
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Salary');
    XLSX.writeFile(wb, this.fileName);
  }


  // generateAllPayroll(){
  // this.showSkeleton = true;
  // const month_char = this.month_char;
  // const year = this.month_year; 
  // const month_in = this.month_int;
  // this.dashboardService.genrateAllPayroll(month_char, year, month_in).then((value:any) => {
  //         if (value.success == true) {
  //           Swal.fire({
  //             iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
  //             title: value.message,
  //             showConfirmButton: false,
  //             timer: 2000,
  //           });
  //          this.showSkeleton = false;
  //         }
  //         else {
  //           Swal.fire({
  //             iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
  //             title: value.message,
  //             showConfirmButton: false,
  //             timer: 2000,
  //           });
  //         }
  //       this.showSkeleton = false;
  //     });


  // }


  progressInterval: any; // <-- define in your component class

  generateAllPayroll() {
    this.actionOptions = false;
    this.activeSubMenu = null;
    this.showSkeleton = true;
    const month_char = this.month_char!;
    const year = this.month_year!;
    const month_in = this.month_int!;

    // 🔹 Get total first from backend
    this.dashboardService.getPayrollProgress(month_in, year).then((initialProgress: any) => {
      const totalUsers = initialProgress.total || 0;

      // 🔹 Open Swal with correct total
      Swal.fire({
        title: 'Generating Payroll',
        html: `<p id="progress-text">0 salary generated out of ${totalUsers}</p>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });

      // 🔁 Start polling progress every second
      this.progressInterval = setInterval(() => {
        this.dashboardService.getPayrollProgress(month_in, year)
          .then((progress: any) => {
            const textEl = document.getElementById('progress-text');
            if (textEl) {
              textEl.innerText = `${progress.generated} salary generated out of ${progress.total}`;
            }

            // ✅ Stop polling when complete
            if (progress.generated >= progress.total && progress.total > 0) {
              clearInterval(this.progressInterval);
              Swal.close();
            }
          });
        this.getData(month_char, year, month_in);
      }, 1000);

      // 🔹 Start actual payroll generation
      this.dashboardService.genrateAllPayroll(month_char, year, month_in)
        .then((value: any) => {
          clearInterval(this.progressInterval); // stop polling just in case

          if (value.success) {
            Swal.fire({
              iconHtml: '<img src="../../assets/images/success-modal.svg">',
              title: value.message,
              showConfirmButton: false,
              timer: 2000
            });

            this.checkSalary(year, month_in);

            this.showSkeleton = false;


          } else {
            Swal.fire({
              iconHtml: '<img src="../../assets/images/error-modal.svg">',
              title: value.message,
              showConfirmButton: false,
              timer: 2000
            });
          }
        });



    });
  }



  actionConformation(action: any) {
    const selectedUsers = this.getSelectedUsers();
    const status = action

    // 🔴 Safety check
    // if (!selectedUsers.length) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'No User Selected',
    //     text: 'Please select at least one user.',
    //   });
    //   return;
    // }
    if (!selectedUsers.length) {
      $('#comformModal').modal('hide');
      $('#errorModal').modal('show');
      return;
    }
    this.showSkeleton = true;

    // 🔹 Extract salary IDs
    const salaryIds = selectedUsers
      .map((user: any) => user?.user_salary?.[0]?.id)
      .filter((id: any) => id); // remove nulls

    if (!salaryIds.length) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Selection',
        text: 'Selected users have no payroll record.',
      });
      return;
    }


    this.dashboardService.genrateSelectedPayroll(salaryIds, status)
      .then((value: any) => {

        $('#comformModal').modal('hide');
        this.showSkeleton = false;

        const updatedCount = value.updated?.length || 0;
        const skippedCount = value.skipped?.length || 0;

        /* ============================
           CASE 1: FULL SUCCESS
        ============================ */
        if (updatedCount > 0 && skippedCount === 0) {
          Swal.fire({
            iconHtml: '<img src="../../assets/images/success-modal.svg">',
            title: value.message,
            text: `${updatedCount} salary record(s) updated successfully.`,
            timer: 2500,
            showConfirmButton: false
          });
        }

        /* ============================
           CASE 2: PARTIAL SUCCESS
        ============================ */
        else if (updatedCount > 0 && skippedCount > 0) {

          const skippedMessages = value.skipped
            .map((s: any) => `• Salary ID ${s.salary_id}: ${s.message}`)
            .join('<br>');

          Swal.fire({
            icon: 'warning',
            title: 'Partially Completed',
            html: `
          <p><b>${updatedCount}</b> updated successfully.</p>
          <p><b>${skippedCount}</b> skipped:</p>
          <div style="text-align:left">${skippedMessages}</div>
        `,
            confirmButtonText: 'OK'
          });
        }

        /* ============================
           CASE 3: ALL SKIPPED
        ============================ */
        else if (updatedCount === 0 && skippedCount > 0) {

          const skippedMessages = value.skipped
            .map((s: any) => `• Salary ID ${s.salary_id}: ${s.message}`)
            .join('<br>');

          Swal.fire({
            icon: 'info',
            title: 'No Changes Made',
            html: skippedMessages,
            confirmButtonText: 'OK'
          });
        }

        // 🔄 Refresh data
        this.cancelSelection();
        this.getData(this.month_char!, this.month_year!, this.month_int!);
      })
      .catch(() => {
        this.showSkeleton = false;
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong',
          text: 'Unable to update payroll. Please try again.',
        });
      });

  }



  get isPayrollGenerated(): boolean {
    return !!this.total_salary_id;
  }

  bulkAction(action: any) {
    this.actionOptions = false;
    this.activeSubMenu = null;
    this.showSkeleton = true;

    const month_char = this.month_char;
    const year = this.month_year;
    const month_in = this.month_int;
    const status = action;

    this.dashboardService.bulkActionPayroll(year, month_in, status)
      .then((value: any) => {
        this.showSkeleton = false;

        const updatedCount = value.updated?.length || 0;
        const skippedCount = value.skipped?.length || 0;

        // ============================
        // CASE 1: FULL SUCCESS
        // ============================
        if (updatedCount > 0 && skippedCount === 0) {
          Swal.fire({
            iconHtml: '<img src="../../assets/images/success-modal.svg">',
            title: value.message,
            text: `${updatedCount} salary record(s) updated successfully.`,
            timer: 2500,
            showConfirmButton: false
          });
        }

        // ============================
        // CASE 2: PARTIAL SUCCESS
        // ============================
        else if (updatedCount > 0 && skippedCount > 0) {
          const skippedMessages = value.skipped
            .map((s: any) => `• Salary ID ${s.salary_id}: ${s.message}`)
            .join('<br>');

          Swal.fire({
            icon: 'warning',
            title: 'Partially Completed',
            html: `
            <p><b>${updatedCount}</b> updated successfully.</p>
            <p><b>${skippedCount}</b> skipped:</p>
            <div style="text-align:left">${skippedMessages}</div>
          `,
            confirmButtonText: 'OK'
          });
        }

        // ============================
        // CASE 3: ALL SKIPPED
        // ============================
        else if (updatedCount === 0 && skippedCount > 0) {
          const skippedMessages = value.skipped
            .map((s: any) => `• Salary ID ${s.salary_id}: ${s.message}`)
            .join('<br>');

          Swal.fire({
            icon: 'info',
            title: 'No Changes Made',
            html: skippedMessages,
            confirmButtonText: 'OK'
          });
        }

        // Refresh table
        if (month_char && year && month_in) {
          this.getData(month_char, year, month_in);
        }

      })
      .catch(() => {
        this.showSkeleton = false;
        Swal.fire({
          icon: 'error',
          title: 'Something went wrong',
          text: 'Unable to update payroll. Please try again.',
        });
      });
  }

  updateChart(counts: { approved: number; released: number; draft: number }) {
    this.chartOptions = {
      ...this.chartOptions,
      series: [
        { name: 'Release', data: [0, counts.released] },
        { name: 'Approved', data: [0, counts.approved] },
        { name: 'Draft', data: [0, counts.draft] }
      ]

    };
  }


  prepareDeductionGraph(totaldeduction: any) {
    // 🔹 Use totals calculated in getData
    const total =
      totaldeduction;

    this.deductionGraphData = [
      {
        label: 'Absents',
        amount: this.total__absents,
        percentage: total ? Math.round((this.total__absents / total) * 100) : 0,
        color: '#7064FF'
      },
      {
        label: 'Late Check-In',
        amount: this.total_lateCheckin,
        percentage: total ? Math.round((this.total_lateCheckin / total) * 100) : 0,
        color: '#836BDC'
      },
      {
        label: 'Short Hours',
        amount: this.total_shourtHours,
        percentage: total ? Math.round((this.total_shourtHours / total) * 100) : 0,
        color: '#9773B8'
      },
      {
        label: 'Unpaid Leaves',
        amount: this.total_unpaidLeaves,
        percentage: total ? Math.round((this.total_unpaidLeaves / total) * 100) : 0,
        color: '#D9AA7A95'
      },
      {
        label: 'Loan Amount',
        amount: this.loan_amount,
        percentage: total ? Math.round((this.loan_amount / total) * 100) : 0,
        color: '#BD8172'
      }
    ];
    console.log(this.deductionGraphData,);
  }

  cumulativePercentage(index: number) {
    let sum = 0;
    for (let i = 0; i < index; i++) {
      sum += this.deductionGraphData[i].percentage;
    }
    return sum; // returns sum of previous percentages
  }


  editCase(data: any) {
    // Set default month/year if not provided
    const currentMonthInt = this.month_int;
    const currentMonthYear = this.month_year;
    const currentMonthChar = this.month_char;

    this.router.navigate(['/manual-payroll'], {
      state: {
        user: data,
        monthInt: currentMonthInt,
        monthYear: currentMonthYear,
        monthChar: currentMonthChar
      }
    });
  }
  goBack() {
    this.location.back();
  }




  getMonthPayroll() {
    const Month_int = this.month_int; // 1–12
    const year = this.month_year;
    this.payrollService.getPayrollMonth(Month_int, year)
      .then((value: any) => {
        if (value.success) {

          const data = value?.data;
          this.total_salary_id = data?.id
        }
      });
  }


  checkSalary(year: number, monthInt: number) {
    this.payrollService.getmonthSalary(year, monthInt).then((value: any) => {
      const data = value?.data
      this.exist_salary = value?.exists
      this.salary_status = value?.status
      console.log(data);
    });

  }
  getdetailMonthPayroll() {
    const id = this.payrol_id
    this.payrollService.getdetailPayrollMonth(id)
      .then((value: any) => {
        if (value.success) {
          const data = value?.data;
          this.total_salary_id = data?.id
          this.exist_status = data?.status
          if (this.exist_status === 'draft' || this.exist_status == '' || this.exist_status == undefined) {
            this.enableGraph = false;
          } else {
            this.enableGraph = true;
          }
        }
      });
  }









  getcurrentData() {
    debugger
    this.dashboardService.getAllUserSalariesCurrnetMonthly().then((value: any) => {
      this.usersList = value.data;

      // Sort according to status: approved/released first, then draft, etc.
      this.usersList.sort((a: any, b: any) => {
        const getWeight = (user: any) => {
          const status = user?.user_salary?.[0]?.status?.trim().toLowerCase() || 'draft';
          if (status === 'approved' || status === 'released') return 1;
          if (status === 'draft') return 3;
          return 2;
        };
        return getWeight(a) - getWeight(b);
      });

      this.month_data = value.responsecode

      if (this.month_data == null) {
          Swal.fire({
            iconHtml: '<img src="../../assets/images/error-modal.svg">',
            title: 'Error',
            text: 'No Salary in Process',
            timer: 2500,
            showConfirmButton: false
          }).then(() => {
            window.history.back(); // go to previous page
          });
        }

      this.totalSalary = 0
      this.totalDeduction = 0
      this.totalReleasedSalary = 0
      this.total_shourtHours = 0
      this.total_lateCheckin = 0
      this.total_unpaidLeaves = 0
      this.total__absents = 0
      this.total_Advance = 0
      this.total_Overtime = 0
      this.total_tax = 0
      this.loan_amount = 0
      this.total_otherDeduction = 0
      this.total_Compensation = 0
      this.total_shourtHours_count = 0
      this.total_lateCheckin_count = 0
      this.total_unpaidLeaves_count = 0
      this.total_absents_count = 0
      this.status = 'draft';
      this.usersList.forEach((user: any) => {
        if (user.user_salary?.length > 0) {
          this.totalSalary += parseFloat(user.user_salary[0].basic_salary)
          if (user.user_salary[0].total_deduction != null) {
            this.totalDeduction += parseFloat(user.user_salary[0].total_deduction)
          }
          if (user.user_salary[0].released_salary != null) {
            this.totalReleasedSalary += parseFloat(user.user_salary[0].released_salary)
          }

          if (user.user_salary[0].short_hours_amount != null) {
            this.total_shourtHours += parseFloat(user.user_salary[0].short_hours_amount)
          }

          if (user.user_salary[0].short_hours != null) {
            this.total_shourtHours_count += parseFloat(user.user_salary[0].short_hours)
          }

          if (user.user_salary[0].late_check_in_amount != null) {
            this.total_lateCheckin += parseFloat(user.user_salary[0].late_check_in_amount)
          }

          if (user.user_salary[0].late_check_in != null) {
            this.total_lateCheckin_count += parseFloat(user.user_salary[0].late_check_in)
          }

          if (user.user_salary[0].unpaid_leaves_amount != null) {
            this.total_unpaidLeaves += parseFloat(user.user_salary[0].unpaid_leaves_amount)
          }

          if (user.user_salary[0].unpaid_leaves != null) {
            this.total_unpaidLeaves_count += parseFloat(user.user_salary[0].unpaid_leaves)
          }


          if (user.user_salary[0].absents_amount != null) {
            this.total__absents += parseFloat(user.user_salary[0].absents_amount)
          }
          if (user.user_salary[0].absents != null) {
            this.total_absents_count += parseFloat(user.user_salary[0].absents)
          }

          if (user.user_salary[0].advance_payment != null) {
            this.total_Advance += parseFloat(user.user_salary[0].advance_payment)
          }

          if (user.user_salary[0].overtime_amount != null) {
            this.total_Overtime += parseFloat(user.user_salary[0].overtime_amount)
          }

          if (user.user_salary[0].tax != null) {
            this.total_tax += parseFloat(user.user_salary[0].tax)
          }
          // Loan Amount munib
          if (user.user_salary[0].loan_deduction_amount != null) {
            this.loan_amount += parseFloat(user.user_salary[0].loan_deduction_amount)
          }
          if (user.user_salary[0].other_deduction != null) {
            this.total_otherDeduction += parseFloat(user.user_salary[0].other_deduction)
          }

          if (user.user_salary[0].compensation_amount != null) {
            this.total_Compensation += parseFloat(user.user_salary[0].compensation_amount)
          }
          if (user.user_salary[0].status != null) {
            this.status += parseFloat(user.user_salary[0].status)
          }
        }
      });
      console.log(this.totalDeduction, this.totalSalary);
      // Set month_char and month_year
      const firstSelectedSalary = this.getCurrentSelectedSalary(this.usersList[0]);
      this.month_char = firstSelectedSalary?.month_char;
      this.month_year = firstSelectedSalary?.month_year;
      this.month_int = firstSelectedSalary?.month_int;
      this.payrol_id = this.month_data.id
      this.getdetailMonthPayroll();
      this.statusCounts = this.getStatusCounts(this.usersList);
      this.updateChart(this.statusCounts);
      this.prepareDeductionGraph(this.totalDeduction);
      if (this.month_year != null && this.month_int != null) {
        this.checkSalary(this.month_year, this.month_int);
      }
      this.getMonthPayroll();

      this.showSkeleton = false;

    });
  }
  getCurrentSelectedSalary(user: any) {
    return user.user_salary?.find((s: any) => s.is_selected);
  }




  PayrollChecks(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.payroll?.data?.values;

    switch (type) {
      case "isAdd":
        return values?.add ?? false;

      case "isApprove":
        return values?.approve ?? false;

      case "isDetail":
        return values?.detail ?? false;

      case "isPreview":
        return values?.preview ?? false;

      case "isRelease":
        return values?.release ?? false;

      case "ismonthly":
        return values?.view_monthly ?? false;

      case "isSumary":
        return values?.view_summary ?? false;

      default:
        return false;
    }
  }

  user_refresh(): void {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user;
      this.user = this.refresh;
      const userInfo = this.user;
      this.resignationapi = value.data.resign_status;
      this.resign_status = value.data.resign_status?.status ?? '';

      if (userInfo != null) {
        this.user = this.user;
      }


    })

  }
}
